import { render } from "./Order.vue?vue&type=template&id=71eef25e"
const script = {}

import exportComponent from "D:\\Workspace\\na-doskah.ru\\crm.na-doskah.ru.v1.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__